import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetIsB2BForbiddingMessageShownActionType, TIsB2BForbiddingMessageShown } from './types';

export const setIsB2BForbiddingMessageShown: (isB2BForbiddingMessageShown: boolean) => TIsB2BForbiddingMessageShown =
  actionGenerator<ESetIsB2BForbiddingMessageShownActionType.Set, boolean>(
    ESetIsB2BForbiddingMessageShownActionType.Set,
  );
